var map = {
	"./website/subComponents/autoload": "GK8i"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "gJHW";


//////////////////
// WEBPACK FOOTER
// . ^\.\/.*\/subComponents\/autoload$
// module id = gJHW
// module chunks = 50